import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { userProfileQueries } from '@/services/userProfile/userProfile.queries';

export const useGetUserProfile = () => {
  const { data, isFetched, isLoading } = useQuery({ ...userProfileQueries() });

  return {
    userData: data || null,
    isFetched,
    isLoading,
  };
};

export default useGetUserProfile;
